import { EMPTY } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
// ---- external imports -----

import { levelSelectors } from '~/store';
import { LEVEL_UPDATE_MISSIONS } from '~/store/level/actionTypes';
// ---- internal imports ----

import goToNextLevel$ from './goToNextLevel$';
// ---- local imports ----


const checkInstantLevelUpEpic = (action$, state$) => action$.pipe(
	ofType(LEVEL_UPDATE_MISSIONS),
	concatMap(() => (checkInstantLevelUp(state$.value)))
);

function checkInstantLevelUp(state) {
	const isInstantLevelUp = levelSelectors.isInstantLevelUp(state);

	if (isInstantLevelUp) {
		const missions = levelSelectors.getMissions(state);
		const hasCompletedMissions = missions.every((mission) => (mission.completed));

		if (hasCompletedMissions) {
			return goToNextLevel$(state);
		}
	}

	return EMPTY;
}


export default checkInstantLevelUpEpic;
